<template>
  <div>
    <transition name="slide">
      <more-about
        v-show="showMore"
        :data="event"
        :category="categoryId"
        :artist-more="eventArtistName"
        @close="closeAbout"/>
    </transition>
    <el-container
      v-loading.fullscreen.lock="fullscreenLoading"
      class="container-events">
      <template>
        <div
          :style="bannerImage"
          class="background-img-event grid-container-event">
          <div class="gradient"/>
          <div class="btn-route">
            <i
              class="icon-arrow-left"
              @click="goToBack"/>
            <span>{{ nameRoute }}</span>
          </div>
          <el-row
            class="grid-content-event">
            <el-col
              :span="1"
              :class="categoryIcon"
              class="col-icon-event">
              <div class="event-icon">
                <i
                  v-if="categoryId === 3 "
                  class="icon-music-icon music-category background-category"/>
                <i
                  v-else-if="categoryId === 4 "
                  class="icon-sports-icon sports-category background-category"/>
                <i
                  v-else-if="categoryId === 5 "
                  class="icon-arts-icon arts-category background-category"/>
                <i
                  v-else-if="categoryId === 6 "
                  class="icon-kids-icon kids-category background-category "/>
                <i
                  v-else-if="categoryId === 7 "
                  class="icon-special-icon special-category background-category"/>
              </div>
            </el-col>
            <el-col
              :span="22"
              class="hidden-xs-only">
              <el-row class="event-name-and-tags">
                <el-col
                  :span="24"
                  class="event-name">
                  <h1>{{ event.name }}</h1>
                </el-col>
                <el-col
                  :span="24"
                  class="event-dates">
                  <span>Del {{ datesRange[0] }} al {{ datesRange[1] }}</span>
                </el-col>
                <el-col class="category-event">
                  <span>{{ categoryName }}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </template>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="icon-bullet-icon">
          <el-breadcrumb-item :to="{ name: 'Home' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Eventos</el-breadcrumb-item>
          <el-breadcrumb-item>{{ event.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div
        class="grid-container">
        <el-row
          class="grid-content">
          <el-col
            :span="6"
            class="about-event-col hidden-xs-only">
            <div class="event-date-and-price">
              <el-row>
                <el-col
                  :span="12"
                  class="label-card">Desde</el-col>
                <el-col
                  :span="12"
                  class="label-card">Presentaciones</el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="12"
                  class="data-event">$60</el-col>
                <el-col
                  :span="12"
                  class="data-event">
                  <span>
                    {{ event.totalPresentations }}
                  </span>
                </el-col>
              </el-row>
            </div>
            <div class="event-about">
              <el-row>
                <el-col><b>Sobre este evento</b></el-col>
                <el-col>
                  <p
                    class="event-description"
                    v-html="event.description"/>
                </el-col>
                <el-col>
                  <b class="title-participe">Participan</b>
                  <div
                    v-for="artist in eventArtistName"
                    :key="artist.id"
                    class="artist-participe"
                    @click="goToArtist(artist.id)">
                    <div
                      :style="{backgroundImage: `url(${artist.profileImage})`}"
                      class="profile-img-artist"/>
                    <span class="name-artist">{{ artist.artistName }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div>
              <mt-secure-buy/>
            </div>
          </el-col>
          <el-col
            :offset="1"
            :span="17"
            class="dates-event">
            <div class="hidden-sm-and-up">
              <div class="title-and-tags">
                <div class="title">
                  <h1>{{ event.name }}</h1>
                  <span>{{ categoryName }}</span>
                </div>
              </div>
              <div class="more-about-event">
                <el-button
                  class="btn-more"
                  @click="goToAbout">Más sobre éste evento</el-button>
                <el-row
                  :gutter="3"
                  class="states-and-dates-responsive">
                  <el-col
                    :span="12"
                    class="state-show-responsive">
                    <mt-select-states/>
                  </el-col>
                  <el-col
                    :span="12"
                    class="dates-show-responsive">
                    <mt-select-date/>
                  </el-col>
                </el-row>
              </div>
            </div>
            <el-row class="header-date-and-states">
              <el-col
                :span="12"
                class="state-show hidden-xs-only">
                <span>Mostrando fechas en {{ statesNull }} </span>
              </el-col>
              <el-col
                :span="12"
                class="date-show hidden-xs-only">
                <el-row>
                  <el-col :span="12">
                    <el-date-picker
                      v-model="dateEvents"
                      type="date"
                      style="width: 100%"
                      format="yyyy/MM/dd"
                      placeholder="Fechas"/>
                  </el-col>
                  <el-col :span="12">
                    <el-select
                      v-model="statesNull"
                      placeholder="Estado">
                      <el-option
                        v-for="(item, index) in uniqueMunicipallity"
                        :key="index"
                        :label="item"
                        :value="item"/>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <div v-if="eventPresentations.length >=1">
              <mt-date-row
                v-for="(presentation, index) in eventPresentations"
                v-if="presentation.time"
                :key="index"
                :venue-event="presentation.venue.name"
                :date-event="presentation.startDate"
                :name-event="event.name">
                <!--<el-row
                  v-for="(hour, index) in presentation.time"
                  :key="index"
                  class="second-row">
                  <el-col
                    :xs="2"
                    :sm="2"
                    :md="2"
                    :lg="2"
                    :xl="2"
                    class="hour-event">
                    <span>{{ hour }}hrs</span>
                  </el-col>
                  <el-col
                    :xs="17"
                    :sm="15"
                    :md="15"
                    :lg="15"
                    :xl="15"
                    class="available-tickets">
                    <div class="available-content">
                      <span>+1000&nbsp;</span>
                      <span class="second-span hidden-xs-only">boletos</span>
                      <i class="icon-special-icon"/>
                    </div>
                  </el-col>
                  <el-col
                    :xs="5"
                    :sm="7"
                    :md="7"
                    :lg="7"
                    :xl="7"
                    class="buy-tickets">
                    <el-button @click="goToZone(hour, presentation.venue.name, presentation.startDate)">Comprar</el-button>
                  </el-col>
                </el-row>-->
                <div class="ticket-on-sale">
                  <span>Boletos en venta unicamente el día del evento y en taquillas de la feria</span>
                </div>
              </mt-date-row>
            </div>
            <div
              v-else
              class="no-date-event">
              <h1>No existen fechas para este evento</h1>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-container>
  </div>
</template>

<script>

import moment from 'moment'
import mtSelectStates from '../_shared/mt-select-states'
import mtSelectDate from '../_shared/mt-select-date'
import mtDateRow from '../_shared/mt-date-row'
import mtSecureBuy from '../_shared/mt-secure-buy'
import states from '../_shared/states/states'
import moreAbout from '../events/more-about-event'
export default {
  name: 'ReadEvents',
  components: {
    mtDateRow, mtSecureBuy, mtSelectStates, mtSelectDate, moreAbout
  },
  props: {
    nameRoute: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      numberDate: [],
      fullscreenLoading: false,
      scrollBlock: 'scroll',
      statesMexico: states.states,
      statesNull: '',
      dateEvents: '',
      eventArtistId: {},
      eventArtistName: [],
      eventPresentations: {},
      event: {},
      showMore: false,
      statesById: {},
      datesRange: [],
      categoryId: 0,
      categoryIcon: 'identifier-' + this.categoryId,
      categoryName: ''

    }
  },
  computed: {
    uniqueMunicipallity () {
      let removeId = []
      for (let i = 0; i < this.eventPresentations.length; i++) {
        if (!removeId.includes(this.eventPresentations[i].venue.municipality)) {
          removeId.push(this.eventPresentations[i].venue.municipality)
        }
      }
      return removeId
    },
    /// ///////////////////////
    bannerImage () {
      return {
        backgroundImage: 'url(' + this.event.coverImage + ')'
      }
    },
    profileImg () {
      return {
        backgroundImage: 'url(' + this.event.thumbImage + ')'
      }
    }
  },
  mounted () {
    this.fullscreenLoading = true
    Promise.all([
      this.$store.dispatch('events/get', {id: this.$route.params.id, with: 'category'}),
      this.$store.dispatch('eventArtist/query', {'filters[where][eventId][eq]': this.$route.params.id}),
      this.$store.dispatch('presentations/query', {'filters[where][eventId][eq]': this.$route.params.id, with: 'venue', sort: 'startDate asc'})
    ]).then((response) => {
      this.event = response[0].data
      this.event.category = response[0].data.category
      this.eventArtistId = response[1].data.items
      this.eventPresentations = response[2].data.items
      this.eventPresentations.pagination = response[2].data.pagination
      /* GET NAME OF ARTIST */
      for (let i = 0; i < this.eventArtistId.length; i++) {
        this.$store.dispatch('artist/get', {id: this.eventArtistId[i].artistId}).then((response) => {
          this.eventArtistName.push(response.data)
        })
      }
      /* GET DATES OF EVENT */
      for (let j = 0; j <= this.eventPresentations.length; j++) {
        if (j === 0) {
          this.datesRange.push(moment(this.eventPresentations[j].startDate).format('LL'))
        }
        if (j === this.eventPresentations.length - 1) {
          this.datesRange.push(moment(this.eventPresentations[j].endDate).format('LL'))
        }
      }
      this.recursitive(this.eventPresentations, [], 0)
    }).catch((e) => {
    }).finally(() => {
      this.fullscreenLoading = false
      this.categoryId = this.event.category.parentId
      this.categoryName = this.event.category.name
    })
  },
  methods: {
    recursitive (array, res, it) {
      if (array.length > it) {
        let eventDay = array[it]
        if (res.length === 0) {
          res.push(
            Object.assign(eventDay, {
              date: moment(eventDay.startDate).format('YYYY-MM-DD'),
              time: [moment(eventDay.startDate).format('h:mm')]
            })
          )
          return this.recursitive(array, res, it + 1)
        } else {
          let position = this.indexof(res, eventDay)
          if (position !== -1) {
            res[position].time.push(moment(eventDay.startDate).format('h:mm'))
            return this.recursitive(array, res, it + 1)
          } else {
            res.push(
              Object.assign(eventDay, {
                date: moment(eventDay.startDate).format('YYYY-MM-DD'),
                time: [moment(eventDay.startDate).format('h:mm')]
              })
            )
            return this.recursitive(array, res, it + 1)
          }
        }
      } else {
        return res
      }
    },

    indexof (res, eventDay) {
      let exists = -1
      res.forEach((item, index) => {
        if (item.venueId === eventDay.venueId && item.date === moment(eventDay.startDate).format('YYYY-MM-DD')) {
          exists = index
        }
      })
      return exists
    },
    goToZone (hour, venue, date) {
      let zoneObject = {venue: venue, date: date, hour: hour}
      this.$store.dispatch('setData', zoneObject)
      this.$router.push({name: 'Zonas', params: zoneObject})
    },
    goToBack () {
      this.$router.go(-1)
    },
    goToArtist (id) {
      this.$router.push({name: 'Artista', params: {id: id}})
    },
    goToAbout () {
      this.showMore = true
      document.body.style.overflow = 'hidden'
    },
    closeAbout () {
      this.showMore = false
      document.body.style.overflow = 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
  .ticket-on-sale{
    text-align: center;
    span{
      @include font-primary(14px, bold);
      color: $roseHeader;
    }
  }

  .grid-container{
    padding-top: 0;
    @media #{$Elementxs} {
     padding: 0;
    }
    .grid-content{
      padding-top: 30px;
    }
  }
  .grid-container-event{
    padding-top: 0;
    position: relative;
    width: 100%;
    .grid-content-event{
      background-color: transparent;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 1280px;
      transition: all .3s ease-in-out;
      @media #{$Laptop} {
        width: 100%;
        padding: 00px 50px 0 90px;
      }
      @media #{$Elementxs} {
        padding: 0 30px 20px 15px;
      }
    }
  }

  .dates-event{
    @media #{$Elementxs} {
      width: 100%;
      margin-left: 0;
    }
  }

  .info-event {
    position: sticky;
    top: 544px;
    width: 100%;
  }

  .artist-participe {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition:  all .3s ease-in-out;
    padding: 5px;
    margin-top: 10px;
    &:hover{
      background-color: #f5f5f5;
      border-radius: 4px;
    }
    .profile-img-artist {
      width: 30px;
      height: 30px;
      background-size: cover;
      border-radius: 50%;
    }
    .name-artist {
      @include font-primary(14px, regular);
      color: $carbon;
      margin-left: 15px;
    }
  }
.col-icon-event{
  margin-right: 30px;
  .event-icon {
    margin-top: 15px !important;
    @media #{$NoteS} {
      margin-bottom: 15px !important;
    }
    @media #{$iPhoneSE} {
      margin-bottom: 5px !important;
    }
    i {
      margin: 0 auto;
      color: white;
      font-size: 28px;
      @media #{$iPhoneSE} {
        font-size: 18px;
      }
    }
  }
}

  .event-date-and-price{
    //height: 70px;
    padding: 22px;
    border-radius: 2px;
    background-color: white;
    margin-bottom: 20px;
    .label-card{
      @include font-primary(10px, semibold);
      color: $roseHeader;
    }
    .data-event {
      @include font-primary(16px, regular);
      color: #444444;
    }
  }
  .event-about{
    padding: 22px;
    border-radius: 2px;
    margin-bottom: 50px;
    background-color: white;
    .event-description{
      @include font-primary(14px !important, regular !important);
      color: $carbon !important;
    }
    .cast{
      margin-top: 20px;
      display: flex;
      align-items: center;
      span{
        margin-left: 15px;
      }
    }
    .event-profile-image{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-size: cover;
      background-position: center;
    }
  }

  .remove-padding{
    padding: 0 !important;
    width: 100%;
  }

  .header-date-and-states {
    margin-bottom: 15px;
    .state-show {
      span {
        @include font-primary(14px, semibold);
        color: $carbon;
      }
    }
    .date-show {
      .el-row {
        .el-col {
          float: right;
        }
      }
    }
  }

  .no-date-event{
    text-align: center;
    display: flex;
    align-items: center;
    height: 200px;
    margin-top: 10px;
    h1{
      @include font-primary(18px, regular);
      margin: 0 auto;
      color: $carbon;
    }
  }

  //////////BUY TICKETS
  .second-row{
    width: 100%;
    height: 40px;
    &:not(:last-child){
      margin-bottom: 20px;
    }
    .hour-event {
      span{
        line-height: 40px;
        color: $carbon;
        @include font-primary(13px, regular);
      }
    }
    .available-tickets {
      height: 40px;
      .available-content {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .second-span{
          margin-right: 23px;
        }
        span {
          @include font-primary(12px, semibold);
          color: #2894FF;
          @media #{$Elementxs} {
            margin-right: 23px;
          }
        }
        i {
          color: #2894FF;
          margin-right: 22px;
          font-size: 15px;
          @media #{$Elementxs} {
            margin-right: 19px;
          }
        }
      }
    }
    .buy-tickets {
      @media #{$Elementxs} {
        padding-right: 10px;
      }
      @media #{$Note} {
        padding-right: 0;
      }
      button {
        background-color: $roseHeader;
        width: 100%;
        height: 40px;
        padding: 0;
        border: none;
        color: #F9D9DE;
        @include font-primary(14px, bold);
        @media #{$Elementxs} {
          background-color: transparent;
          color: $roseHeader;
          width: 100%;
          text-align: right;
        }
      }
    }
  }

  /////ANIMATIONS

  .slide-enter-active {
    transition: all .3s ease-in-out;
  }
  .slide-leave-active {
    transition: all .3s ease-in-out;
  }
  .slide-enter, .slide-leave-to {
    transform: translateX(100%);
  }

  ///RESPOSNIVE

  .title-and-tags {
    margin-bottom: 7px;
    .title{
      margin-bottom: 5px;
      h1{
        margin: 0;
      }
    }
  }

  .more-about-event{
    padding: 0 !important;
    .btn-more{
      width: 100%;
      margin-bottom: 10px;
      border: none;
      background-color: transparent;
      color: $roseHeader;
      @include font-primary(12px, semibold);
    }
    .states-and-dates-responsive{
      margin-bottom: 15px;
      width: 100%;
      display: flex;
      .state-show-responsive{
        width: 50%;
      }
      .dates-show-responsive{
        width: 50% !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/events/read-events.vue